module.exports = __webpack_public_path__ + "static/futurpreneur-logo-64a15cda0634b45f9ff7a6b812c6f979.png";